import { FlowAlarmTestChangeM610 } from './Data/M610';

export const selectFlowAlarmTestData = (formName, formData, flowAlarmTestPoint) => {
    let filterViewData = { rows: [] };
    if (['M6-10'].includes(formName)) {
        filterViewData = FlowAlarmTestChangeM610(formData, flowAlarmTestPoint);
    }
    return filterViewData;
};
